import {
  batteryProposalPath,
  batterySetupMenuPath,
  isBatteryContractPath,
  isBatteryFinancingStatusPath,
  isBatterySetupMenuOpen,
  isBatterySharePath,
  stepFromPath,
} from "./setup-steps"
import {
  proposalSetupEscapeCommand,
  type ProposalSetupEscapeCommand,
  type ProposalSetupEscapeEvent,
} from "../../ProposalSetup/proposal-setup-shortcuts"

/**
 * Escape on a Battery path. Step, Contract, Share and Financing Status drawers
 * handle their own Escape, so the rail leaves those paths alone.
 */
export const batterySetupEscapeCommand = ({
  pathname,
  proposalId,
  ...event
}: ProposalSetupEscapeEvent & {
  readonly pathname: string
  readonly proposalId: string
}): ProposalSetupEscapeCommand =>
  proposalSetupEscapeCommand({
    ...event,
    drawerOwnsEscape:
      stepFromPath(pathname) != null ||
      isBatteryContractPath(pathname) ||
      isBatterySharePath(pathname) ||
      isBatteryFinancingStatusPath(pathname),
    pathname,
    proposalPath: batteryProposalPath(proposalId),
    setupMenuOpen: isBatterySetupMenuOpen(pathname),
    setupMenuPath: batterySetupMenuPath(proposalId),
  })
